<template>
  <transition name="modal">
    <div class="modalMask" v-show="show" @click.stop="handleClick">
      <div class="modalWrapper">
        <div class="modalContainer" @click.stop>
          <div class="modalHeader">
            <slot name="header"></slot>
          </div>
          <div class="modalBody">
            <slot name="body"></slot>
          </div>
          <div v-show="!noFooter" class="modalFooter">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    },
    preventDimmedClick: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleClick() {
      if (!this.noFooter) {
        if (this.isConfirmOpen) {
          if (typeof this.closeCallback === 'function') this.closeCallback()
        } else if (typeof this.callback === 'function') {
          this.callback()
        }
        this.closeModal()
      }
    }
  },
  computed: {
    ...mapGetters('modal', [
      'isConfirmOpen',
      'isAlertOpen',
      'callback',
      'closeCallback'
    ])
  },
  updated() {
    if (this.isAlertOpen || this.isConfirmOpen) {
      document.querySelector('body').style.overflow = 'hidden'
    } else {
      document.querySelector('body').style.overflow = 'auto'
    }
  }
}
</script>

<style lang="scss">
.modalMask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.68);
  display: table;
  transition: opacity 0.3s ease;
}

.modalWrapper {
  display: table-cell;
  padding: 0 47px;
  vertical-align: middle;
}

.modalContainer {
  width: 100%;
  padding: 10px;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modalHeader {
  h1 {
    height: 25px;
    padding: 5px 0 0;
    margin: 0;
    font-size: 15px;
    color: #151721;
    text-align: center;
    font-weight: normal;
  }
}

.modalBody {
  display: table;
  width: 100%;
  min-height: 97px;
  font-size: 15px;
  line-height: 20px;
  & > div {
    display: table-cell;
    padding: 10px 0 20px;
    text-align: center;
    vertical-align: middle;
  }
  table {
    width: 100%;
    font-size: 12px;
    border: 1px solid #d6d6db;
    border-bottom: 1px solid #d6d6db;
    margin: -10px 0 0;
  }
  th,
  td {
    height: 30px;
    text-align: left;
    padding: 5px 13px 4px;
    border-bottom: 1px solid #d6d6db;
    vertical-align: middle;
  }
  th {
    width: 40%;
    font-weight: bold;
    background-color: #e9eaf1;
  }
  table + p {
    padding: 5px 0 0 14px;
    text-indent: -14px;
    margin-bottom: -12px;
    text-align: left;
    line-height: 15px;
    font-size: 11px;
    color: #636376;
  }
}
.modalBodyBg {
  width: 100%;
  min-height: 86px;
  padding: 10px 7px 7px;
  margin: -10px 0 -10px;
  background-color: #e9eaf1;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
  vertical-align: middle;
  .alignCenter {
    text-align: center;
  }
  p + dl {
    margin-top: 12px;
  }
  dl {
    line-height: 18px;
  }
  dt,
  dd {
    display: inline-block;
    vertical-align: top;
  }
  dt {
    width: 56px;
    font-weight: bold;
    &::after {
      content: ' |';
      display: inline;
      font-weight: normal;
    }
  }
  dd {
    width: calc(100% - 56px);
  }
}
.valignMiddle {
  display: table;
  p {
    display: table-cell;
    vertical-align: middle;
  }
}
.modalFooter {
  height: 38px;
  button {
    height: 38px;
    border-radius: 4px;
  }
  .button51,
  .button52,
  .button53 {
    width: calc(50% - 3px);
    margin-right: 6px;
    &:last-child {
      margin-right: 0;
    }
  }
  .button13,
  .button53 {
    color: #2a2e43;
    border: 1px solid #2a2e43;
    background-color: #fff;
    &:disabled {
      color: #8e93b3;
      border-color: #8e93b3;
    }
  }
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modalContainer,
.modal-leave-active .modalContainer {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
@media all and (min-width: 426px) {
  .modalContainer {
    max-width: 332px;
  }
}
</style>
